import React, { useState } from 'react';
import { Modal, Box, TextField, MenuItem, CircularProgress, Button, IconButton } from '@material-ui/core';

const modalWrapperStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  maxHeight: '90vh',
  backgroundColor: 'white',
  borderRadius: 12,
  boxShadow: 24,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
};

const headerStyle = {
  backgroundColor: '#75287C',
  color: 'white',
  padding: '0px 24px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  minHeight: 56,
};

const contentStyle = {
  padding: 24,
  flex: 1, // take remaining space
  overflowY: 'auto',
};

const actionsStyle = {
  padding: '16px 24px',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 12,
  borderTop: '1px solid #eee',
};

const FormModalCompliance = ({ setIsModalOpen, open, onClose, formData, handleInputChange, uniqueComplianceInstanceId, isPersonaLoading, isEdit, handleUpdateButtonClick, submitCompliancePersonaForm, complianceAlreadyFilledPersonaInstanceId, selectedInstanceResourceId }) => {
  // const [formData, setFormData] = useState({
  //   nResourceInstanceId: '',
  //   'Shop Act': '',
  //   'Udyam Registration': '',
  //   GST: '',
  //   'FSSAI registration': '',
  //   'FSSAI license': '',
  //   Other: '',
  // });

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  const renderForm = () => (
    <Box>
      {isPersonaLoading && <CircularProgress className="center-screen" />}

      <TextField
        select
        name="nResourceInstanceId"
        label="Resource Instance Id"
        value={formData["nResourceInstanceId"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        // SelectProps={{
        //   MenuProps: {
        //     PaperProps: {
        //       style: {
        //         maxHeight: 200,
        //         width: 300,
        //       },
        //     },
        //   },
        // }}

        SelectProps={{
          MenuProps: {
            PaperProps: {
              style: {
                maxHeight: 200,
                width: 300,
              },
            },
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null, // Very important in MUI v4
          },
        }}

        disabled={isEdit ? true : true} // resource id change nahi hone paye so disablibng for both add and edit
      >
        {uniqueComplianceInstanceId.map((option) => (
          <MenuItem key={option} value={option}
            disabled={complianceAlreadyFilledPersonaInstanceId?.includes(option)}
          >{option}</MenuItem>
        ))}
      </TextField>

      <TextField
        select
        name="Shop Act"
        label="Shop Act"
        value={formData["Shop Act"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        disabled={selectedInstanceResourceId !== "SHOPACT"}
        style={{
          display: `${selectedInstanceResourceId !== "SHOPACT" ? "none" : "block"}`
        }}
      >
        {['Provided by deAsra', 'Existing'].map((option) => (
          <MenuItem key={option} value={option}>{option}</MenuItem>
        ))}
      </TextField>

      <TextField
        select
        name="Udyam Registration"
        label="Udyam Registration"
        value={formData["Udyam Registration"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        disabled={selectedInstanceResourceId !== "UDYAMREG"}
        style={{
          display: `${selectedInstanceResourceId !== "UDYAMREG" ? "none" : "block"}`
        }}
      >
        {['Provided by deAsra', 'Existing'].map((option) => (
          <MenuItem key={option} value={option}>{option}</MenuItem>
        ))}
      </TextField>

      <TextField
        select
        name="GST"
        label="GST"
        value={formData["GST"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        disabled={selectedInstanceResourceId !== "GSTREG"}
        style={{
          display: `${selectedInstanceResourceId !== "GSTREG" ? "none" : "block"}`
        }}
      >
        {['Provided by deAsra', 'Existing'].map((option) => (
          <MenuItem key={option} value={option}>{option}</MenuItem>
        ))}
      </TextField>

      <TextField
        select
        name="FSSAI registration"
        label="FSSAI registration"
        value={formData["FSSAI registration"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        disabled={selectedInstanceResourceId !== "FSSAI"}
        style={{
          display: `${selectedInstanceResourceId !== "FSSAI" ? "none" : "block"}`
        }}
      >
        {['Provided by deAsra', 'Existing'].map((option) => (
          <MenuItem key={option} value={option}>{option}</MenuItem>
        ))}
      </TextField>

      <TextField
        select
        name="FSSAI license"
        label="FSSAI license"
        value={formData["FSSAI license"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        disabled={selectedInstanceResourceId !== "FSSAILICENSE"}
        style={{
          display: `${selectedInstanceResourceId !== "FSSAILICENSE" ? "none" : "block"}`
        }}
      >
        {['Provided by deAsra', 'Existing'].map((option) => (
          <MenuItem key={option} value={option}>{option}</MenuItem>
        ))}
      </TextField>

      <TextField
        select
        name="Cashflow Management"
        label="Cashflow Management"
        value={formData["Cashflow Management"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        disabled={selectedInstanceResourceId !== "CASHBUGTMGMT"}
        style={{
          display: `${selectedInstanceResourceId !== "CASHBUGTMGMT" ? "none" : "block"}`
        }}
      >
        {['Provided by deAsra', 'Existing'].map((option) => (
          <MenuItem key={option} value={option}>{option}</MenuItem>
        ))}
      </TextField>

      <TextField
        name="Other"
        label="Other"
        value={formData["Other"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        disabled={
          selectedInstanceResourceId == "SHOPACT" ||
          selectedInstanceResourceId == "UDYAMREG" ||
          selectedInstanceResourceId == "GSTREG" ||
          selectedInstanceResourceId == "FSSAI" ||
          selectedInstanceResourceId == "FSSAILICENSE" ||
          selectedInstanceResourceId == "CASHBUGTMGMT" ||
          !selectedInstanceResourceId
        }
        style={{
          display: `${selectedInstanceResourceId == "SHOPACT" ||
            selectedInstanceResourceId == "UDYAMREG" ||
            selectedInstanceResourceId == "GSTREG" ||
            selectedInstanceResourceId == "FSSAI" ||
            selectedInstanceResourceId == "FSSAILICENSE" ||
            selectedInstanceResourceId == "CASHBUGTMGMT" ||
            !selectedInstanceResourceId ? "none" : "block"
            }`
        }}
      />
    </Box>
  );

  return (
    <Modal open={open} onClose={onClose}>
      <Box style={modalWrapperStyle}>

        {/* Header */}
        <Box style={headerStyle}>
          <div>Compliance Persona Form</div>
          <IconButton onClick={onClose} style={{ color: 'white' }}>
            X
          </IconButton>
        </Box>

        {/* Form content */}
        <Box style={contentStyle} className={`${isPersonaLoading ? "set-opacity" : ""}`}>
          {renderForm()}
        </Box>

        {/* Action Buttons */}
        <Box style={actionsStyle}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          {
            isEdit ? (
              <Button variant="contained" style={{ backgroundColor: '#75287C', color: 'white' }} onClick={() => handleUpdateButtonClick(formData)}>
                Update
              </Button>
            ) : (
              <Button variant="contained" style={{ backgroundColor: '#75287C', color: 'white' }} onClick={() => submitCompliancePersonaForm(formData)}>
                Submit
              </Button>
            )
          }
        </Box>

      </Box>
    </Modal>
  );
};

export default FormModalCompliance;
